import type { User } from "../../models/User";
import type { WPProductConfig } from "../../models/WPProductConfig";
import type { WPTestGroup } from "../../models/WPTestGroup";
import { configRefs } from "../constants/config";
import { DAYS_TO_MS, HOURS_TO_MS } from "../constants/time";
import { createCache } from "../createCache";

import type { ApiClientOptions } from "./typings/ApiClientOptions";
import type { ApiRequestInterceptor } from "./typings/ApiRequestInterceptor";
import { fetchRequest, NOT_FOUND_ERROR } from "./utils/fetchRequest";

const HARDCODED_PORTAL_ID = "7dd9f657-596f-4956-9245-644e3db4ec0c";

export function makeFetchTeacherAvailableTests(
  requestInterceptor: ApiRequestInterceptor,
  options: ApiClientOptions,
) {
  const cache = createCache<WPTestGroup[]>({
    timeToLiveMs: 1 * HOURS_TO_MS,
    timeToEvictMs: 1 * DAYS_TO_MS,
    ...options,
  });

  return (user: User, product: WPProductConfig) => {
    return cache(`i:${user.institutionId}-p:${product.id}`, async () => {
      try {
        const response = await fetchRequest<WPTestGroup>(
          requestInterceptor(
            `${await configRefs.apis.webproever.get()}/${HARDCODED_PORTAL_ID}/products/${product.id}/exams/${user.institutionId}`,
          ),
        );

        return response.produktKategorier ?? [];
      } catch (err) {
        if (err === NOT_FOUND_ERROR) {
          return [];
        } else {
          throw err;
        }
      }
    });
  };
}
